import { createSlice } from "@reduxjs/toolkit";

const removeNulls = (obj) => {
  for (var propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName];
    }
  }
  return obj;
};

const initialState = {
  data: {},
  serviceFunction: "",
};
const formSlice = createSlice({
  name: "currentForm",
  initialState,
  reducers: {
    resetForm: (state) => {
      // for (const key in initialState) {
      //   state[key] = initialState[key];
      // }
      state.data=initialState.data
    },
    resetServiceFunction:(state)=>{
      state.serviceFunction = initialState.serviceFunction;
    },
    setData: (state, data) => {
      state.data = { ...removeNulls(data) };
    },
    setServiceFunction: (state, func) => {
      state.serviceFunction = func;
    },
  },
});
const { reducer, actions } = formSlice;
export const { setData, setServiceFunction, resetForm, resetServiceFunction } = actions;
export default reducer;
